import { useQuery } from '@tanstack/react-query';
import { defaultFolderApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useDocumentTemplateDetail(templateId: string) {
  return useQuery({
    queryKey: queryKeys.documentTemplates.detail(templateId),
    queryFn: ({ signal }) =>
      defaultFolderApiClient.getTemplateById(templateId, toCancelToken(signal)),
    enabled: templateId !== '',
    staleTime: 0,
    meta: { errorContext: 'document template' },
  });
}
